import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-af0f6684"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "display_range" }
const _hoisted_2 = { key: 0 }

import APP from '@/js/const/app'
import { computed, withDefaults } from 'vue'

type PropsType = {
  total: number | null
  currentPage: number
  isLoaded: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'DisplayRange',
  props: {
    total: { default: null },
    currentPage: { default: 1 },
    isLoaded: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { total: number | null, currentPage: number, isLoaded: boolean };



const pageSize = APP.PAGE_LIMIT

const start = computed<number>(() => (props.currentPage - 1) * pageSize + 1)

const end = computed<number>(() => {
  const end = props.currentPage * pageSize
  // totalがnullの場合表示されないですので必要ないだがエラー表示があって追加
  if (!props.total) {
    return 0
  }
  return end < props.total ? end : props.total
})

return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.isLoaded)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
          _createElementVNode("span", null, _toDisplayString(_ctx.$t('display_range.displaying', { total: __props.total, start: _unref(start), end: _unref(end) })), 1)
        ]))
      : _createCommentVNode("", true)
  ], 512)), [
    [_vShow, __props.total]
  ])
}
}

})